import Vue from "vue";
import App from "./App.vue";
import * as VueGoogleMaps from "vue2-google-maps";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;
const rootElement = document.querySelector("#rentpress-app");
let tempOptions = JSON.parse(rootElement.dataset.options);

Vue.use(VueGoogleMaps, {
  load: {
    key: tempOptions.rentpress_google_maps_api_section_api_key ?? ""
  },
  installComponents: true
});

Vue.mixin({
  methods: {
    sendGAEvent(category, action, label) {
      if (window.ga) {
        window.ga("send", "event", category, action, label);
      } else {
        return "nothing happened";
      }
    },
    gtag() {
      if (tempOptions.rentpress_google_analytics_api_section_tracking_id) {
        window.dataLayer.push(arguments);
      }
      if (
        typeof arguments[1] != "undefined" &&
        typeof arguments[2] != "undefined"
      ) {
        let keys = Object.keys(arguments[2]);
        var data = {
          event: arguments[1]
        };
        for (var i = keys.length - 1; i >= 0; i--) {
          let key = keys[i];
          data[key] = arguments[2][key];
        }
        if (!tempOptions.rentpress_google_analytics_api_section_tracking_id) {
          window.dataLayer.push(data);
        }
      }
    }
  }
});

new Vue({
  vuetify,

  render: h => {
    const context = {
      props: { ...rootElement.dataset }
    };
    return h(App, context);
  }
}).$mount("#rentpress-app");
